export default class SnackbarManager {
  constructor(snackbarTarget) {
    this.snackbarTarget = snackbarTarget;
  }

  show(message) {
    const snackbar = this.snackbarTarget;
    const content = snackbar.querySelector('.snackbar__content');
    content.textContent = message;
    snackbar.classList.add('show');
    
    setTimeout(() => {
      snackbar.classList.remove('show');
    }, 5000);
  }
} 